<template>
  <el-menu
    :show-timeout="200"
    :default-active="path"
    mode="vertical"
    @select="path => menuSelect(path)">
    <Item 
      v-for="item in routes"
      :key="item.name" 
      :data="item"/>
  </el-menu>
</template>

<script>
import Item from './Item.vue'
import routes from '@/router'
import { copyObj } from '@/utils'
import { mapGetters } from 'vuex'
import * as NodePath from 'path'
import { useKeyPress } from './keyPress'
export default {
  data () {
    return {
      routes: []
    }
  },
  computed: {
    path(){
      return this.$route.path
    },
    ...mapGetters(['auth', 'isDev'])
  },
  mixins: [useKeyPress],
  components: {
    Item
  },
  methods: {
    menuSelect(path){
      let isLink = /^(https?:|mailto:|tel:)/.test(path);
      if(isLink){
        window.open(path, this.isCtrl ? '_blank' : '_self')
      }else{
        this.isCtrl
        ? window.open(location.origin + path, '_blank')
        : this.$router.push(path)
      }
    },
    filterRoutes(routes, prevPath = ''){
      //判断是否匹配权限、是否隐藏、是否为root
      return routes.map(
        item => {
          if(item.meta){
            let { hide, auth } = item.meta
            if(hide)
              return
            if(
              !this.isDev &&
              auth && 
              this.auth.indexOf(auth) == -1)
              return
          }
          item.path = NodePath.resolve(prevPath, item.path)
          if(!item.meta)
            item.meta = {}
          //判断是否为root
          item.meta.isRoot = item.children && 
            item.children.length 
              ? false 
              : true
          if(item.children && 
            item.children.length)
            item.children = this.filterRoutes(item.children, item.path)
          if(!item.meta.isRoot){
            //如果是root但是子项长度为0，则不显示该项
            if(!item.children.length)
              return
            //如果是root但是子项长度为1，且alwaysShow不为true则合并子项
            if(!item.meta.alwaysShow && 
              item.children.length == 1){
              let child = item.children[0]
              item = {
                ...child,
                meta: {
                  ...item.meta,
                  ...child.meta
                },
                path: NodePath.resolve(item.path, child.path)
              }
            }
          }
          return item
        }
      ).filter(
        item => item != undefined
      )
    }
  },
  mounted(){
    this.routes = this.filterRoutes(
      copyObj(this.$router.options.routes)
    )
  }
}
</script>

<style lang="scss" scoped>
.el-menu{
  >>> .el-menu-item,
  >>> .el-submenu__title{
    display: flex;
    align-items: center;
    line-height: initial;
    height: 4rem;
    font-size: 1.2rem;
    column-gap: .8rem;
    svg{
      font-size: 1.3rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar/Menu/index.vue